import { HIDE_OVERLAY, SHOW_OVERLAY, OverlayActionTypes, OverlayState } from './types'

const initialState: OverlayState = {
  isVisible: false
}

export function overlayReducer(
  state: OverlayState = initialState,
  action: OverlayActionTypes
): OverlayState {
  switch (action.type) {
    case SHOW_OVERLAY:
      return {
        isVisible: true,
        title: action.payload.title
      }
    case HIDE_OVERLAY:
      return {
        isVisible: false
      }
    default:
      return state
  }
}
